import React, { useState, Fragment, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { Dialog, Transition } from "@headlessui/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { useFormState } from "./Context";
import { useForm } from "./useForm";
import { NumberInput } from "./NumberInput";
import { Button } from "./ui/Button";
import { InputContact } from "./ui/InputContact";

function isGenericEmail(email) {
  const forbiddenDomains = ["gmail.com", "hotmail.com", "yahoo.com"];
  const domain = email.split("@")[1];
  return forbiddenDomains.includes(domain.toLowerCase());
}

function validateEmail(value) {
  let error;
  if (!value) {
    error = "Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = "Invalid email address";
  } else if (isGenericEmail(value)) {
    error = "Please provide your business email.";
  }
  return error;
}

function noEmpty(value) {
  let error;
  if (!value) {
    error = "Required";
  }
  return error;
}

function App() {
  const [formState, setFormState] = useFormState();
  const { sendToHubSpot } = useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  function closeModal() {
    setIsModalOpen(false);
  }

  useEffect(() => {
    sessionStorage.removeItem("OverMax");
    sessionStorage.removeItem("PricingGap");
    sessionStorage.removeItem("MaterialOptimization");
    sessionStorage.removeItem("IncrementalNetworkOptimization");
  }, []);

  return (
    <>
      <div className="tw-max-w-[584px]  tw-flex">
        <div className="tw-flex-1 tw-max-w-3xl">
          <div>
            <Formik
              initialValues={{
                onHandInventory: "",
                estimated12Months: "",
                numberOfPlants: "",
                numberOfSKUs: "",
                numberOfEmployees: "",
              }}
              // validationSchema={roiSchema}
              onSubmit={async (values) => {
                setFormState(values);
                // setSubmitting(false);
                setIsModalOpen(true);
              }}
            >
              {({ isSubmitting }) => {
                console.log(isSubmitting);
                return (
                  <Form className="tw-bg-[#003252] tw-rounded-3xl tw-p-10 ">
                    <div className="tw-space-y-3">
                      <div className="tw-flex tw-flex-col ">
                        <label className="tw-mb-1 tw-text-white tw-text-[17px]">
                          <span className="tw-font-bold ">
                            On-Hand-Inventory{" "}
                          </span>{" "}
                          <span className="tw-italic">(Required)</span>
                        </label>
                        <Field
                          className="tw-rounded-lg tw-h-12 tw-text-[#003252] tw-px-2"
                          type="number"
                          name="onHandInventory"
                          required
                          component={NumberInput}
                        />
                      </div>
                      <div className="tw-flex tw-flex-col">
                        <label className="tw-my-1 tw-text-white tw-text-[17px]">
                          <span className="tw-font-bold">
                            Estimated 12 Months $ of MRO Spend{" "}
                          </span>{" "}
                          <span className="tw-italic">(Required)</span>
                        </label>
                        <Field
                          className="tw-rounded-lg tw-h-12 tw-text-blue-900 tw-px-2"
                          type="number"
                          name="estimated12Months"
                          required
                          component={NumberInput}
                        />
                      </div>
                      <div className="tw-flex tw-flex-col ">
                        <label className="tw-my-1 tw-text-white tw-text-[17px]">
                          <span className="tw-font-bold">Number of Plants</span>{" "}
                        </label>
                        <Field
                          className="tw-rounded-lg tw-h-12 tw-text-blue-900 tw-px-2"
                          type={"number"}
                          name="numberOfPlants"
                          component={NumberInput}
                        />
                      </div>
                      <div className="tw-flex tw-flex-col ">
                        <label className="tw-my-1 tw-text-white tw-text-[17px]">
                          <span className="tw-font-bold">
                            Number of SKUs on-Hand{" "}
                          </span>{" "}
                        </label>
                        <Field
                          className="tw-rounded-lg tw-h-12 tw-text-blue-900 tw-px-2"
                          type="number"
                          name="numberOfSKUs"
                          component={NumberInput}
                        />
                      </div>
                      <div className="tw-flex tw-flex-col ">
                        <label className="tw-my-1 tw-text-white tw-text-[17px]">
                          <span className="tw-font-bold">
                            {" "}
                            Number of Employees
                          </span>{" "}
                        </label>
                        <Field
                          className="tw-rounded-lg tw-h-12 tw-text-blue-900 tw-px-2"
                          type="number"
                          name="numberOfEmployees"
                          component={NumberInput}
                        />
                      </div>
                    </div>
                    <Button className="tw-font-bold" type="submit">
                      ACCESS MY REPORT
                    </Button>
                  </Form>
                );
              }}
            </Formik>

            <Transition appear show={isModalOpen} as={Fragment}>
              <Dialog
                as="div"
                className="tw-relative tw-z-10"
                onClose={closeModal}
              >
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-25" />
                </Transition.Child>

                <div className="tw-fixed tw-inset-0 tw-overflow-y-auto">
                  <div className="tw-flex min-h-full tw-items-center tw-justify-center tw-p-4 tw-text-center">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 scale-95"
                      enterTo="opacity-100 scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 scale-100"
                      leaveTo="opacity-0 scale-95"
                    >
                      <Dialog.Panel className="tw-w-full tw-max-w-md tw-transform tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-p-6 tw-text-left tw-align-middle tw-shadow-xl tw-transition-all">
                        <div className="tw-mt-2">
                          <p className="tw-text-lg tw-text-center tw-font-bold tw-text-blue-900">
                            Just one more thing!
                          </p>
                          <p className=" tw-text-center tw-text-blue-900">
                            Please provide your name to access your results.
                          </p>
                        </div>
                        <div>
                          <Formik
                            initialValues={{
                              firstname: "",
                              lastname: "",
                              email: "",
                              title: "",
                              company: "",
                            }}
                            onSubmit={(values) => {
                              sendToHubSpot({ ...formState, ...values });
                              // window.location.href = "https://verusen.com/?page_id=3903&preview=true";
                            }}
                          >
                            {(formik) => {
                              console.log(formik);
                              return (
                                <Form className="tw-mt-4">
                                  <div className="tw-space-y-3">
                                    <div className="tw-flex tw-flex-col ">
                                      <label className="tw-mb-1 tw-font-semibold tw-text-[#003252]">
                                        First Name
                                      </label>
                                      <InputContact
                                        validate={noEmpty}
                                        type="text"
                                        name="firstname"
                                      />
                                      <div className="tw-text-red-600 tw-font-bold tw-mt-1">
                                        {" "}
                                        {formik.errors.firstname &&
                                          formik.touched.firstname && (
                                            <div>{formik.errors.firstname}</div>
                                          )}
                                      </div>
                                    </div>
                                    <div className="tw-flex tw-flex-col ">
                                      <label className="tw-mb-1 tw-font-semibold tw-text-[#003252]">
                                        Last Name
                                      </label>
                                      <InputContact
                                        validate={noEmpty}
                                        type="text"
                                        name="lastname"
                                      />
                                      <div className="tw-text-red-600 tw-font-bold tw-mt-1">
                                        {" "}
                                        {formik.errors.lastname &&
                                          formik.touched.lastname && (
                                            <div>{formik.errors.lastname}</div>
                                          )}
                                      </div>
                                    </div>
                                    <div className="tw-flex tw-flex-col ">
                                      <label className="tw-font-semibold  tw-my-1 tw-text-[#003252]">
                                        Email
                                      </label>
                                      <InputContact
                                        validate={validateEmail}
                                        type="email"
                                        name="email"
                                      />
                                      <div className="tw-text-red-600 tw-font-bold tw-mt-1">
                                        {" "}
                                        {formik.errors.email &&
                                          formik.touched.email && (
                                            <div>{formik.errors.email}</div>
                                          )}
                                      </div>
                                    </div>
                                    <div className="tw-flex tw-flex-col ">
                                      <label className="tw-font-semibold tw-my-1 tw-text-[#003252]">
                                        Title
                                      </label>
                                      <InputContact
                                        validate={noEmpty}
                                        type="text"
                                        name="title"
                                      />
                                      <div className="tw-text-red-600 tw-font-bold tw-mt-1">
                                        {" "}
                                        {formik.errors.title &&
                                          formik.touched.title && (
                                            <div>{formik.errors.title}</div>
                                          )}
                                      </div>
                                    </div>
                                    <div className="tw-flex tw-flex-col ">
                                      <label className="tw-my-1 tw-font-semibold tw-text-[#003252]">
                                        Company
                                      </label>
                                      <InputContact
                                        validate={noEmpty}
                                        type="text"
                                        name="company"
                                      />
                                      <div className="tw-text-red-600 tw-font-bold tw-mt-1">
                                        {" "}
                                        {formik.errors.company &&
                                          formik.touched.company && (
                                            <div>{formik.errors.company}</div>
                                          )}
                                      </div>
                                    </div>
                                    <div className="tw-mt-4 tw-flex tw-justify-center space-x-4 tw-mt-10">
                                      <button
                                        type="button"
                                        className="tw-flex tw-px-14 tw-justify-center tw-align-middle tw-rounded-md tw-border tw-border-transparent tw-bg-blue-100 tw-tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-blue-900 tw-hover:bg-blue-200 tw-focus:outline-none tw-focus-visible:ring-2 tw-focus-visible:ring-blue-500 tw-focus-visible:ring-offset-2"
                                        onClick={closeModal}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="submit"
                                        className="tw-ml-2 tw-px-14 tw-flex tw-justify-center tw-align-middle tw-rounded-md tw-border tw-border-transparent tw-bg-green-600  tw-py-3 tw-text-sm tw-font-medium tw-text-white tw-hover:bg-blue-200 tw-focus:outline-none tw-focus-visible:ring-2 tw-focus-visible:ring-blue-500 tw-focus-visible:ring-offset-2"
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </div>
                                </Form>
                              );
                            }}
                          </Formik>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default App;
